import * as React from "react";
import { GridItem } from "@chakra-ui/react";
import { Button, Form, Grid, Link, NumberInput } from "components";
import {
  ExpirationDate,
  LicenseAutoComplete,
  OrganizationAutoComplete,
  StartDate
} from "./components";
import { FormValues, getValidation } from "./duck";

interface OrdersFormProps {
  defaultValues?: FormValues;
  onSubmit(values: FormValues): Promise<any>;
}

const OrdersForm: React.FC<OrdersFormProps> = ({ defaultValues, onSubmit }) => {
  const { validationSchema, emptyDefaultValues } = getValidation();
  return (
    <Form<FormValues>
      onSubmit={onSubmit}
      defaultValues={defaultValues || (emptyDefaultValues as any)}
      validationSchema={validationSchema}
    >
      <Grid py={6} templateColumns="repeat(2, 1fr)">
        <GridItem>
          <LicenseAutoComplete />
        </GridItem>
        <GridItem>
          <OrganizationAutoComplete />
        </GridItem>

        <GridItem>
          <StartDate />
        </GridItem>

        <GridItem>
          <ExpirationDate />
        </GridItem>

        <GridItem>
          <NumberInput
            name="price"
            min={0}
            label="Order Price (USD)"
            placeholder="Order Price (USD)"
          />
        </GridItem>
      </Grid>
      <Form.Controls submitText="Save">
        <Button
          as={Link}
          to="/order-management"
          replace
          colorScheme="gray"
          variant="outline"
        >
          Cancel
        </Button>
      </Form.Controls>
    </Form>
  );
};

export default OrdersForm;
